import { Modal } from "acma-spa/dist/layout/Modal"

export type LoginAction = "myid" | "email" | "none";  

export interface LoginWarningModalProps {
    onClose: (action: LoginAction) => void
}

export const LoginWarningModal: React.FC<LoginWarningModalProps> = (props) => {
    return <Modal
        size="lg"
        id="loginWarning"
        open={true}
        onClose={() => props.onClose("none")}
        title="Before you continue"
        leftButtons={[
            {
                label: "Continue with Digital ID",
                onClick: () => props.onClose("myid")
            },
            {
                label: "Use email login (if eligible)",
                onClick: () => props.onClose("email"),
                mode: "secondary",
            },
        ]}
    >
        <p>Most users should log in with Digital ID, including all <b>new ACMA Assist users</b> and <b>SMS Sender ID Register users</b>.</p>
        <p>Email login is only available for some <b>ACMA Assist accounts created before November 2025</b>.</p>
    </Modal>
}